import { API_ERROR_MESSAGE } from '../../utils/Constants'
import { API_CALL_TYPE, getAPIUrl } from '../API'
import { makeApiCall } from '../APIService'
import jwt_decode from 'jwt-decode'
import { decode } from 'punycode'

interface handleUserAuthenticateProps {
  setErrorMessage: (message: string) => void
  setIsError: (isError: boolean) => void
  setKYCAccess: (KYCAccess: boolean) => void
}
export interface HandleUserAuthenticateResponse {
  statusCode: number
  message?: string
  data: {
    token: string
    KYCAccess?: boolean
  }
}

export const handleUserAuthenticate = async () => {
  const hfAgentEmail =
    (document.getElementById('hfAgentEmail') as HTMLInputElement)?.value ||
    (process.env.REACT_APP_ENV === 'DEV' ? 'owen@cmainfo.co.za' : '')
  const hfPwd =
    (document.getElementById('hfPwd') as HTMLInputElement)?.value ||
    (process.env.REACT_APP_ENV === 'DEV'
      ? 'xcc2657f6a57f3a9aaf3491b8b76a49f3'
      : '')

  const body = {
    username: hfAgentEmail,
    password: hfPwd,
  }

  if (!hfAgentEmail || !hfPwd) {
    throw Error('Email and password hidden fields not set!')
  }

  const res = await fetch(getAPIUrl() + '/User/authenticate', {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
    },
  })

  const response = (await res.json()) as HandleUserAuthenticateResponse
  if (response.statusCode === 200) {
    sessionStorage.setItem('jwt', response.data.token)
  }

  const decoded = jwt_decode(response.data.token) as any
  return {
    ...response,
    data: {
      ...response.data,
      KYCAccess: decoded.KYCAccess.toLowerCase() === 'true',
    },
  }
}

// export const _handleUserAuthenticate = async (
//   props: handleUserAuthenticateProps,
// ) => {
//   const { setErrorMessage, setIsError, setKYCAccess } = props
//   const hfAgentEmail =
//     (document.getElementById('hfAgentEmail') as HTMLInputElement)?.value ||
//     'vincent@fluenty.co.za'

//   const hfPwd =
//     (document.getElementById('hfPwd') as HTMLInputElement)?.value ||
//     'x257348c50f9e002863049442d8644a54' // Encrypted version of "L0nd0n2007$".

//   const body = {
//     username: hfAgentEmail,
//     password: hfPwd,
//   }
//   setErrorMessage('')
//   setIsError(false)
//   return await makeApiCall(
//     API_CALL_TYPE.POST_CALL,
//     getAPIUrl() + '/User/authenticate',
//     (response) => {
//       if (response.statusCode !== 200) {
//         setErrorMessage(API_ERROR_MESSAGE + response?.message)
//         setIsError(true)
//       } else {
//         sessionStorage.setItem('jwt', response.data.token)
//         const decoded = jwt_decode(response.data.token) as any
//         setKYCAccess(decoded.KYCAccess.toLowerCase() === 'true')
//       }
//     },
//     (error) => {
//       console.error(error)
//       setErrorMessage(API_ERROR_MESSAGE)
//       setIsError(true)
//     },
//     body,
//     {},
//     null,
//     false,
//   )
// }
